/******/ (() => { // webpackBootstrap
if (!customElements.get('tab-component')) {
  class TabComponent extends HTMLElement {

    constructor() {
      super();
  
      this.active = this.querySelector('[data-tabs-title].active');
      this.tabs = this.querySelector('[data-active-tab]');
    }
  
    connectedCallback() {
      this.querySelectorAll('[data-tabs-title]').forEach((action) => {
        action.addEventListener('click', this.onActionClick.bind(this))
      });
    }
  
    onActionClick(event) {
      event.preventDefault();
  
      const currentTarget = event.currentTarget;
      const currentId = currentTarget.querySelector('a').getAttribute('href');
      const activeId = this.active.querySelector('a').getAttribute('href');
      if (this.active !== currentTarget) {
        this.active.classList.remove('active');
        this.querySelector(`${activeId}`).classList.remove('is-show');
        currentTarget.classList.add('active');
        this.querySelector(`${currentId}`).classList.add('is-show');
        this.active = currentTarget;
        const item = currentTarget.dataset.item;
        this.tabs.dataset.activeTab = `mega-menu-tab-${item}`;
      }
    }
  }
  customElements.define('tab-component', TabComponent);
}
/******/ })()
;
